import type { FC, ReactNode } from "react";
import type { LogArgs } from "@/shared/lib/fci/logFCI";
import { createSafeContext } from "@/shared/utils/createSafeContext";

const [InnerProvider, useFCIDetailsContext] = createSafeContext<LogArgs["details"]>("FormLoggerContext");

interface FormLoggerProviderProps {
    details: LogArgs["details"];
    children: ReactNode;
}

const FCIDetailsProvider: FC<FormLoggerProviderProps> = ({ details, children }) => (
    <InnerProvider value={details}>{children}</InnerProvider>
);

export { FCIDetailsProvider, useFCIDetailsContext };
